export function Ratio3x2Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="18.75" y="4.375" width="11.25" height="17.5" rx="2" transform="rotate(90 18.75 4.375)" stroke="currentColor" stroke-width="1.6625" />
    </svg>
  );
}

Ratio3x2Icon.displayName = 'Ratio3x2Icon';
